import {
	Component,
	EventEmitter,
	Input,
	OnInit,
	Output,
	ViewChild,
} from '@angular/core';

// --- PrimeNG ---
import { InputNumber } from 'primeng/inputnumber';

// --- Facades ---
import { ParametersFacade } from '@facades/parameters.facade';
import { TenantsFacade } from '@facades/tenants.facade';

// --- Interfaces ---
import type { IProduct } from '@interfaces/product';

// --- Utils ---
import { resolveSaleMultiplier } from '@utils/sale-multiplier.util';

@Component({
	selector: 'app-counter',
	templateUrl: './counter.component.html',
	styleUrls: ['./counter.component.scss'],
})
export class CounterComponent implements OnInit {
	@ViewChild('counterInput') counterInput!: InputNumber;

	@Input() id!: number;
	@Input() cart!: boolean;
	@Input() fullWidth = false;
	@Input() disabled = false;
	@Input() max!: number;
	@Input() product!: IProduct;
	@Input() min = 1;
	@Input() size: 'sm' | 'md' | 'lg' = 'md';
	@Input() step = 1;
	@Input() value = 1;
	@Input() label?: string;
	@Input() set inputId(value: string) {
		if (this.label) this.counterInput.inputId = value || 'quantity';
	}

	@Output() changeEvent = new EventEmitter<number>();
	@Output() changeFavorite = new EventEmitter<any>();

	readonly parameters = this.parametersFacade.parameters;
	readonly tenant = this.tenantFacade.tenant;
	readonly sizes = {
		sm: {
			inputSize: 'p-inputtext-sm',
			buttonSize: 'p-button-sm',
			buttonColor: 'p-button-secondary',
		},
		md: {
			inputSize: 'p-inputtext',
			buttonSize: 'p-button',
			buttonColor: 'p-button-secondary',
		},
		lg: {
			inputSize: 'p-inputtext-lg',
			buttonSize: 'p-button-lg',
			buttonColor: 'p-button-secondary',
		},
	};

	styles = this.sizes.md;

	constructor(
		private parametersFacade: ParametersFacade,
		private tenantFacade: TenantsFacade
	) {}

	ngOnInit(): void {
		this.initializeStockParameters();
	}

	get inputStyleString() {
		return this.styles.inputSize;
	}

	get buttonStyleString() {
		const { buttonSize, buttonColor } = this.styles;
		return `${buttonSize} ${buttonColor}`;
	}

	private initializeStockParameters() {
		this.step = resolveSaleMultiplier(this.step);

		const defaultStoreId =
			this.parameters?.defaultStorehouseId ?? this.parameters?.defaultStoreId;

		const stock = this.product?.stocks?.filter(
			stock => stock.storeId === defaultStoreId
		);

		const quantity = stock?.[0]?.quantity || 0;

		// if (!this.parameters?.allowSellingWithoutStock) {
		// 	if (this.parameters?.cartQuantityLimitPerProduct) {
		// 		this.max =
		// 			quantity < this.parameters.cartQuantityLimitPerProduct
		// 				? quantity
		// 				: this.parameters.cartQuantityLimitPerProduct;
		// 	} else {
		// 		this.max = quantity;
		// 	}
		// } else {
		// 	if (this.parameters.cartQuantityLimitPerProduct) {
		// 		this.max =
		// 			quantity < this.parameters.cartQuantityLimitPerProduct
		// 				? quantity
		// 				: this.parameters.cartQuantityLimitPerProduct;
		// 	} else {
		// 		this.max = Infinity;
		// 	}

		// 	// if (this.enableProductPacking && this.product.packings.length > 0) {
		// 	// } else {
		// 	// 	this.max =  stock && stock.length ? stock[0].quantity : 1;
		// 	// }
		// }

		// * Lógica simplificada para o limite de quantidade no carrinho
		if (this.parameters?.cartQuantityLimitPerProduct) {
			this.max = this.parameters?.allowSellingWithoutStock
				? this.parameters.cartQuantityLimitPerProduct
				: Math.min(quantity, this.parameters.cartQuantityLimitPerProduct);
		} else {
			this.max = this.parameters?.allowSellingWithoutStock
				? Infinity
				: quantity;
		}

		const isStockDecimalWhole = this.parameters.stockDecimalPlaces === 0;
		if (isStockDecimalWhole) {
			this.step = this.step < 1 ? Math.ceil(this.step) : Math.floor(this.step);
			this.max = Math.floor(this.max);
		} else {
			this.step = this.step;
		}

		this.value = this.cart ? this.value : this.step;
		this.min = this.step;

		this.styles = this.sizes[this.size ?? 'md'];
	}

	onChangeValue(value: number) {
		const qtd = parseFloat(value.toFixed(this.parameters.stockDecimalPlaces));

		if (!this.id) return this.changeEvent.emit(qtd);
		return this.changeFavorite.emit({ qtd, id: this.id });
	}
}
